var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4139_4850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7501 1.66663L19.0834 4.99996M2.41675 18.3333L3.48041 14.4332C3.54981 14.1787 3.58451 14.0515 3.63777 13.9329C3.68507 13.8275 3.74318 13.7274 3.81118 13.634C3.88776 13.529 3.98101 13.4357 4.1675 13.2492L12.7787 4.63803C12.9437 4.47303 13.0262 4.39052 13.1213 4.35961C13.205 4.33242 13.2952 4.33242 13.3788 4.35961C13.474 4.39052 13.5565 4.47303 13.7215 4.63803L16.112 7.02855C16.277 7.19356 16.3595 7.27607 16.3904 7.3712C16.4177 7.45488 16.4177 7.54503 16.3904 7.62872C16.3595 7.72385 16.277 7.80636 16.112 7.97137L7.50083 16.5825C7.31434 16.769 7.22109 16.8623 7.11598 16.9389C7.02266 17.0069 6.92251 17.065 6.81718 17.1123C6.69854 17.1655 6.57131 17.2002 6.31686 17.2696L2.41675 18.3333Z",
    stroke: "#2D3B5B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4139_4850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.64fe4bdc0e86b96b136bc8dbba4b5600.svg";
export { ForwardRef as ReactComponent };